import {addTourMedia, deleteLibraryItem, deleteLibraryItemMultiple, getAssignableMediaForTour, getLibrary, getLibraryAndValidate, getLibraryForTour, getStoryMediaForTour, removeTourMedia, getNotificationsForTour, updatePriorityLibraryStory, updatePriorityForTourMedia} from '../../services/LibraryService';

export default {
  namespaced: true,
  state: {
    assignableMedia: [],
    library: {},
    stories: [],
    tourLibrary: {},
    isUploading: false,
    isValidating: false,
    tourNotifications: [],
    uploadError: false,
    uploadResults: null
  },
  getters: {
    getAssignableMedia: (state) => {
      return state.assignableMedia;
    },
    getLibrary: (state) => {
      return state.library;
    },
    getStories: (state) => {
      return state.stories;
    },
    getTourLibrary: (state) => {
      return state.tourLibrary;
    },
    getUploadError: (state) => {
      return state.uploadError;
    },
    isUploading: (state) => {
      return state.isUploading;
    },
    isValidating: (state) => {
      return state.isValidating;
    },
    tourNotifications: (state) => {
      return state.tourNotifications;
    },
    uploadResults: (state) => {
      return state.uploadResults;
    }
  },
  mutations: {
    setAssignableMedia (state, media) {
      state.assignableMedia = media;
    },
    setLanguageOpen (state, indexes) {
      if (state.library[indexes.category][indexes.index]) {
        state.library[indexes.category][indexes.index].expanded = true;
      }
    },
    setLibrary (state, library) {
      state.library = library;
    },
    clearLibrary (state) {
      state.library = {
        story: {},
        filler: {},
        music: {},
        notification: {},
        safety: {}
      };
    },
    setStories (state, media) {
      state.stories = media;
    },
    setTourLibrary (state, library) {
      state.tourLibrary = library;
    },
    setUploadError (state, isError) {
      state.uploadError = isError;
    },
    toggleExpanded (state, indexes) {
      state.library[indexes.category][indexes.index].expanded = !state.library[indexes.category][indexes.index].expanded;
    },
    toggleExpandedAll (state, expand) {
      for (let key in state.library[expand.category]) {
        if (state.library[expand.category].hasOwnProperty(key)) {
          state.library[expand.category][key].expanded = expand.expand;
        }
      }
    },
    setIsUploading (state, toggle) {
      state.isUploading = toggle;
    },
    setIsValidating (state, toggle) {
      state.isValidating = toggle;
    },
    setTourNotifications (state, notifications) {
      state.tourNotifications = notifications;
    },
    setUploadResults (state, results) {
      state.uploadResults = results;
    }
  },
  actions: {
    async removeFromLibrary ({commit}, data) {
      await deleteLibraryItem(data.clientId, data.libraryItemId);
    },
    async removeFromLibraryMultiple ({commit}, data) {
      await deleteLibraryItemMultiple(data.clientId, data.libraryItemId);
    },
    async reorderLibrary ({commit}, data) {
      const responsen = await updatePriorityLibraryStory(data);
      if (responsen.data === 'success') {
        const response = await getLibrary(data.clientId);
        commit('setLibrary', response.data);
        return 'Success';
      }
    },
    async loadAssignableMedia ({commit}, data) {
      const response = await getAssignableMediaForTour(data.clientId, data.tourId, data.type);
      if (response.data === 0) {
        return response.data;
      } else {
        commit('setAssignableMedia', response.data);
      }
    },
    async loadLibrary ({commit}, clientId) {
      commit('clearLibrary');
      const response = await getLibrary(clientId);
      commit('setLibrary', response.data);
    },
    async loadLibraryAndValidate ({commit, dispatch}, clientId) {
      try {
        dispatch('library/isValidatingOn', {}, {root: true});
        await getLibraryAndValidate(clientId);
      } catch (error) {
        dispatch('library/isValidatingOff', {}, {root: true});
        console.log(error);
        throw (error);
      }
    },
    async loadStories ({commit}, data) {
      const response = await getStoryMediaForTour(data);
      commit('setStories', response.data);
    },
    async loadTourLibrary ({commit}, data) {
      const response = await getLibraryForTour(data.clientId, data.tourId);
      commit('setTourLibrary', response.data);
    },
    async reorderTourLibrary ({commit}, data) {
      const responsen = await updatePriorityForTourMedia(data);
      if (responsen.data === 'success') {
        const response = await getLibraryForTour(data.clientId, data.tourId);
        commit('setTourLibrary', response.data);
        return 'Success';
      }
    },
    toggleExpandLanguages ({commit}, indexes) {
      commit('toggleExpanded', indexes);
    },
    toggleExpandLanguagesAll ({commit}, expand) {
      commit('toggleExpandedAll', expand);
    },
    forceLanguageOpen ({commit}, indexes) {
      commit('setLanguageOpen', indexes);
    },
    async addMediaToTour ({commit}, data) {
      try {
        await addTourMedia(data);
      } catch (error) {
        console.log(error);
      }
    },
    async removeMediaFromTour ({commit}, data) {
      try {
        await removeTourMedia(data);
      } catch (error) {
        console.log(error);
      }
    },
    isUploadingOn ({commit}) {
      commit('setIsUploading', true);
    },
    isUploadingOff ({commit}) {
      commit('setIsUploading', false);
    },
    isUploadErrorOn ({commit}) {
      commit('setUploadError', true);
    },
    isUploadErrorOff ({commit}) {
      commit('setUploadError', false);
    },
    isValidatingOn ({commit}) {
      commit('setIsValidating', true);
    },
    isValidatingOff ({commit}) {
      commit('setIsValidating', false);
    },
    async loadTourNotifications ({commit}, payload) {
      try {
        const response = await getNotificationsForTour(payload.tourId, payload.clientId);
        if (response.status === 200) {
          commit('setTourNotifications', response.data);
        }
      } catch (error) {
        console.log(error);
      }
    },
    clearTourNotifications ({commit}) {
      commit('setTourNotifications', []);
    },
    setUploadResults ({commit}, results) {
      commit('setUploadResults', results);
    },
    setValidationResults ({commit}, results) {
      commit('setLibrary', results);
    },
    clearUploadResults ({commit}) {
      commit('setUploadResults', null);
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/libraryModule.js